module.exports = __webpack_public_path__ + "img/sign-49.6e82fe8d.jpg";